import Vue from 'vue'
import Vuex from 'vuex'

import axios from 'axios'
//let res = await axios.post(`${process.env.VUE_APP_HOST}/addVisit`, {

Vue.use(Vuex)
console.log(process.env)
export const store = new Vuex.Store({
    state: {
        token: localStorage.getItem('token') || '',
        status: '',
    },
    getters: {
        authStatus: state => state.status,
        token: state => state.token,
    },
    mutations: {
        auth_request(state) {
            state.status = 'loading'
        },
        auth_success(state, { token }) {
            console.log('commited')
            state.status = 'success'
            state.token = token
        },
    },
    actions: {
        login({ commit }, user) {
            commit('auth_request')
            return new Promise((resolve, reject) => {
                console.log(user)
                let username = user.username;
                let password = user.password;
                axios.post(`http://185.81.96.220/login`, {
                        username,
                        password
                    })
                    .then(resp => {
                        const token = resp.data.data.token
                        localStorage.setItem('token', token)
                            // Add the following line:
                        axios.defaults.headers.common['Authorization'] = token
                        commit('auth_success', { token })
                        resolve(resp)
                    })
                    .catch(err => {
                        localStorage.removeItem('token')
                        reject(err)
                    })
            })
        },
    },
    modules: {}

})